import { getDarkenColor } from "."

export default (type, colors) => {
  const styles = {
    default: {
      "p-offpage__background": {
        customCSS: `
          .p-offpage__background:before {
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          }
        `
      }
    },
    type1: {
      "p-offpage": {
        display: "flex",
        customCSS: `
          .p-offpage main {
            height: 100%;
            display: flex;
            flex-direction: column;
          }
          .p-offpage a {
            background-image: none!important;
          }
          [type=text], [type=password], [type=date], 
          [type=datetime], [type=datetime-local], [type=month], 
          [type=week], [type=email], [type=number], [type=search], 
          [type=tel], [type=time], [type=url], [type=color], textarea {
            margin-bottom: 40px;
            border-radius: 3px;
            padding: 8px 15px;
            height: 50px;
          }
          [type=text]:last-of-type, [type=password]:last-of-type, [type=date]:last-of-type, 
          [type=datetime]:last-of-type, [type=datetime-local]:last-of-type, [type=month]:last-of-type, 
          [type=week]:last-of-type, [type=email]:last-of-type, [type=number]:last-of-type, [type=search]:last-of-type, 
          [type=tel]:last-of-type, [type=time]:last-of-type, [type=url]:last-of-type, [type=color]:last-of-type, textarea:last-of-type {
            margin-bottom: 24px;
          }
        `
      },
      "p-offpage__background": {
        background: colors.primary,
        right: "0",
        left: "auto",
        display: "none",
        customCSS: `
          .p-offpage__background:before {
            background-size: cover;
            background-position: center;
          }
          @media screen and (min-width: 48em) {
            .p-offpage .p-offpage__background {
              width: 50%;
              display: block!important;
            }
          }
          @media screen and (min-width: 64em) {
            .p-offpage .p-offpage__background {
              width: 60%;
              display: block!important;
            }
          }
        `
      },
      "p-offpage__main-content": {
        customCSS: `
          .p-offpage__main-content a,
          .p-offpage__main-content .bottom-links span {
            color: ${getDarkenColor(colors.secondary_dark, 0.23)}
          }
          .p-offpage__main-content .bottom-links a {
            color: ${colors.secondary};
          }
          .p-offpage__main-content .links--underline,
          .p-offpage__main-content a:hover {
            background-image: linear-gradient(rgba(0,0,0,0) 50%, ${getDarkenColor(
              colors.secondary_dark,
              0.23
            )} 50%);
          }
        `
      },
      "p-offpage__main-content--skinny": {
        height: "100%",
        display: "block",
        margin: "0 auto",
        customCSS: `
          .p-offpage__main-content--skinny:before {
            display: none;
          }
        `
      },
      "p-offpage__container": {
        margin: "0",
        height: "100%",
        overflow: "auto",
        customCSS: `
          @media screen and (min-width: 32em) {
            .p-offpage .p-offpage__container {
                width: 100%;
            }
          }
          @media screen and (min-width: 48em) {
            .p-offpage .p-offpage__container {
                width: 50%;
            }
          }
          @media screen and (min-width: 64em) {
           .p-offpage .p-offpage__container {
              width: 40%;
            }
          }
        `
      },
      "p-offpage__inner": {
        height: "100%"
      },
      "p-offpage__inner__row": {
        height: "100%"
      },
      "p-offpage__inner__row__column": {
        height: "100%"
      },
      "p-offpage__title": {
        fontSize: "1.9rem",
        fontWeight: "bold",
        textAlign: "center",
        marginBottom: "35px",
        lineHeight: "normal",
        color: colors.primary
      },
      "p-offpage__form__button": {
        width: "100%",
        height: "52px",
        borderRadius: "3px",
        background: colors.primary
      },
      "p-offpage__login__form": {
        display: "flex",
        flexDirection: "column"
      },
      "p-offpage__actions": {
        order: "2"
      },
      "p-offpage__links": {
        marginTop: "0!important",
        marginBottom: "24px",
        textAlign: "right"
      },
      "p-offpage__bottom__links": {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        margin: "auto 0 30px"
      },
      "p-offpage__bottom__links__text": {
        marginRight: "10px",
        fontSize: "14px"
      },
      "p-offpage__bottom__link": {
        textTransform: "uppercase",
        fontSize: "14px"
      }
    }
  }

  return styles[type]
}



// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/pOffPage.js